import { useEffect, useRef } from 'react';
import { config } from '../config/environment';

export type RealtimeEvent = {
  type: string;
  payload: unknown;
};

interface UseRealtimeUpdatesProps {
  onEvent: (event: RealtimeEvent) => void;
  url?: string;
  onStatusChange?: (status: 'online' | 'offline') => void;
}

export function useRealtimeUpdates({ onEvent, url = config.wsUrl, onStatusChange }: UseRealtimeUpdatesProps) {
  const wsRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    wsRef.current = new WebSocket(url);
    wsRef.current.onopen = () => {
      onStatusChange?.('online');
    };

    wsRef.current.onmessage = (message) => {
      try {
        const event: RealtimeEvent = JSON.parse(message.data);
        onEvent(event);
      } catch (err) {
        // ignore invalid messages
      }
    };

    wsRef.current.onerror = () => {
      onStatusChange?.('offline');
    };

    return () => {
      onStatusChange?.('offline');
      wsRef.current?.close();
    };
  }, [url, onEvent, onStatusChange]);
}
